import { apiRequestFactory } from "@/api/util";

const apiSpec = {
  "/questionnaire/response/export/csv": {
    required: ["questionnaireId"],
    isDataResponse: true,
  },
  "/questionnaire/response/export/geojson": {
    required: ["questionnaireId"],
    isDataResponse: true,
  },
};

const apiRequest = apiRequestFactory(apiSpec);

export default {
  csv: (options, args) => apiRequest(options, "/questionnaire/response/export/csv", args),
  geojson: (options, args) => apiRequest(options, "/questionnaire/response/export/geojson", args),
};
